<div class="changed-data-step-container">
  <form [formGroup]="changedDataForm">
    <div class="job-title-section">
      <div class="section-header">
        <div class="header-content">
          <mat-checkbox
            id="changed-data-step-changes-job-title-checkbox"
            formControlName="hasChangesJobTitle"
            [disabled]="!isJobTitleSectionEnabled"
            color="primary"
          >
            <strong>{{ 'JobTitle' | translate }}</strong>
          </mat-checkbox>

          @if (isJobTitleSectionEnabled) {
            <mat-hint class="section-hint">
              {{ 'Annex.CheckIfAnnexChangesJobTitle' | translate }}
            </mat-hint>
          }
        </div>
        <div class="status-indicator">
          @if (loadingStates['jobTitle']?.isLoading) {
            <mat-spinner diameter="24" color="primary"></mat-spinner>
          }
          @if (loadingStates['jobTitle']?.showSuccess) {
            <mat-icon class="success-icon" @successAnimation> check_circle </mat-icon>
          }
        </div>
      </div>
      @if (hasChangesJobTitle.value) {
        <div class="section-content">
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'OrganizationalUnit' | translate }}</mat-label>
                <input
                  matInput
                  id="changed-data-step-changes-job-title-input"
                  formControlName="organizationalUnit"
                  [matAutocomplete]="autocompleteOrganizationalUnit"
                  readonly
                  (click)="onOrganizationalUnitClick()"
                  class="clickable-field"
                />
                <mat-icon matSuffix (click)="onOrganizationalUnitClick()" class="clickable-field">expand_more</mat-icon>
                <mat-autocomplete #autocompleteOrganizationalUnit="matAutocomplete" [displayWith]="displayValue">
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'JobTitle' | translate }}</mat-label>
                <mat-select formControlName="jobTitle">
                  @for (jobTitle of listOfJobTitles$ | async; track jobTitle) {
                    <mat-option [value]="jobTitle.Id">
                      {{ jobTitle.Name | translate }}
                    </mat-option>
                  }
                </mat-select>
                @if (jobTitle.hasError('sameAsCurrentJobTitle')) {
                  <mat-error>
                    {{ 'Annex.MustBeDifferentThanCurrentVersion' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="supervisor-section">
      <div class="section-header">
        <div class="header-content">
          <mat-checkbox
            id="changed-data-step-changes-supervisor-checkbox"
            formControlName="hasChangesPotentialSupervisor"
            [disabled]="!isSupervisorSectionEnabled"
            color="primary"
          >
            <strong>{{ 'Annex.Supervisor' | translate }}</strong>
          </mat-checkbox>

          @if (isSupervisorSectionEnabled) {
            <mat-hint class="section-hint">
              {{ 'Annex.CheckIfAnnexChangesSupervisor' | translate }}
            </mat-hint>
          }
        </div>
        <div class="status-indicator">
          @if (loadingStates['potentialSupervisor']?.isLoading) {
            <mat-spinner diameter="24" color="primary"></mat-spinner>
          }
          @if (loadingStates['potentialSupervisor']?.showSuccess) {
            <mat-icon class="success-icon" @successAnimation> check_circle </mat-icon>
          }
        </div>
      </div>
      @if (hasChangesPotentialSupervisor.value) {
        <div class="section-content">
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Supervisor' | translate }}</mat-label>
                <input
                  matInput
                  id="changed-data-step-changes-supervisor-input"
                  formControlName="potentialSupervisor"
                  placeholder="{{ 'Supervisor' | translate }}"
                  [matAutocomplete]="autocompleteSupervisor"
                />
                <mat-autocomplete #autocompleteSupervisor="matAutocomplete" [displayWith]="displayValue">
                  @for (supervisor of listOfSupervisors$ | async; track supervisor) {
                    <mat-option [value]="supervisor">
                      {{ supervisor.Name }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (potentialSupervisor.hasError('sameAsCurrentSupervisor')) {
                  <mat-error>
                    {{ 'Annex.MustBeDifferentThanCurrentVersion' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="temporary-workplace-section">
      <div class="section-header">
        <div class="header-content">
          <mat-checkbox
            id="changed-data-step-changes-temporary-workplace-checkbox"
            formControlName="hasChangesTemporaryWorkplace"
            [disabled]="!isTemporaryWorkplaceSectionEnabled"
            color="primary"
          >
            <strong>{{ 'Workplace' | translate }}</strong>
          </mat-checkbox>

          @if (isTemporaryWorkplaceSectionEnabled) {
            <mat-hint class="section-hint">
              {{ 'Annex.CheckIfAnnexChangesTemporaryWorkplace' | translate }}
            </mat-hint>
          }
        </div>
        <div class="status-indicator">
          @if (loadingStates['temporaryWorkplace']?.isLoading) {
            <mat-spinner diameter="24" color="primary"></mat-spinner>
          }
          @if (loadingStates['temporaryWorkplace']?.showSuccess) {
            <mat-icon class="success-icon" @successAnimation> check_circle </mat-icon>
          }
        </div>
      </div>
      @if (hasChangesTemporaryWorkplace.value) {
        <div class="section-content">
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Workplace' | translate }}</mat-label>
                <input
                  matInput
                  id="changed-data-step-changes-temporary-workplace-input"
                  formControlName="temporaryWorkplace"
                  placeholder="{{ 'Workplace' | translate }}"
                  [matAutocomplete]="autocompleteTemporaryWorkplace"
                />
                <mat-autocomplete #autocompleteTemporaryWorkplace="matAutocomplete" [displayWith]="displayValue">
                  @for (temporaryWorkplace of listOfTemporaryWorkplaces$ | async; track temporaryWorkplace) {
                    <mat-option [value]="temporaryWorkplace">
                      {{ temporaryWorkplace.Name }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (temporaryWorkplace.hasError('sameAsCurrentTemporaryWorkplace')) {
                  <mat-error>
                    {{ 'Annex.MustBeDifferentThanCurrentVersion' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="working-time-group-section">
      <div class="section-header">
        <div class="header-content">
          <mat-checkbox
            id="changed-data-step-changes-working-time-group-checkbox"
            formControlName="hasChangesWorkingTimeGroup"
            [disabled]="!isWorkingTimeGroupSectionEnabled"
            color="primary"
          >
            <strong>{{ 'WorkingTimeGroup' | translate }}</strong>
          </mat-checkbox>

          @if (isWorkingTimeGroupSectionEnabled) {
            <mat-hint class="section-hint">
              {{ 'Annex.CheckIfAnnexChangesWorkingTimeGroup' | translate }}
            </mat-hint>
          }
        </div>
        <div class="status-indicator">
          @if (loadingStates['workingTimeGroup']?.isLoading) {
            <mat-spinner diameter="24" color="primary"></mat-spinner>
          }
          @if (loadingStates['workingTimeGroup']?.showSuccess) {
            <mat-icon class="success-icon" @successAnimation> check_circle </mat-icon>
          }
        </div>
      </div>
      @if (hasChangesWorkingTimeGroup.value) {
        <div class="section-content">
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'WorkingTimeGroup' | translate }}</mat-label>
                <mat-select id="changed-data-step-changes-working-time-group-select" formControlName="workingTimeGroupId">
                  @for (workingTimeGroup of listOfWorkingTimeGroups$ | async; track workingTimeGroup) {
                    <mat-option [value]="workingTimeGroup.Id">
                      {{ workingTimeGroup.Name }}
                    </mat-option>
                  }
                </mat-select>
                @if (workingTimeGroupId.hasError('sameAsCurrentWorkingTimeGroup')) {
                  <mat-error>
                    {{ 'Annex.MustBeDifferentThanCurrentVersion' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="wages-section">
      <div class="section-header">
        <div class="header-content">
          <mat-checkbox
            id="changed-data-step-changes-wages-input"
            formControlName="hasChangesWages"
            [disabled]="!isWagesSectionEnabled"
            color="primary"
          >
            <strong>{{ 'Wages' | translate }}</strong>
          </mat-checkbox>

          @if (isWagesSectionEnabled) {
            <mat-hint class="section-hint">
              {{ 'Annex.CheckIfAnnexChangesWages' | translate }}
            </mat-hint>
          }
        </div>
        <div class="status-indicator">
          @if (loadingStates['wage']?.isLoading) {
            <mat-spinner diameter="24" color="primary"></mat-spinner>
          }
          @if (loadingStates['wage']?.showSuccess) {
            <mat-icon class="success-icon" @successAnimation> check_circle </mat-icon>
          }
        </div>
      </div>

      @if (hasChangesWages.value) {
        <div class="section-content">
          @if (wages.invalid && wages.touched && (wages.hasError('noWages') || wages.hasError('noWageChanges'))) {
            <div class="validation-errors">
              @if (wages.hasError('noWages')) {
                <mat-error>
                  {{ 'Annex.AtLeastOneWageRequired' | translate }}
                </mat-error>
              }
              @if (wages.hasError('noWageChanges')) {
                <mat-error>
                  {{ 'Annex.MustBeDifferentThanCurrentVersion' | translate }}
                </mat-error>
              }
            </div>
          }
          @if (hasAnyDescriptiveWageType$ | async) {
            @for (wage of wagesDataSource.data; track wage; let i = $index) {
              <div class="wage-row" formArrayName="wages">
                <div class="wage-fields wage-fields--descriptive" [formGroupName]="i">
                  <div class="wage-field wage-field--type">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'WageType' | translate }}</mat-label>
                      <mat-select formControlName="wageTypeId"
                      [matTooltip]="!isEmploymentAgreementType() ? ('Annex.WageTypeChangeNotAllowed' | translate) : ''" >
                        @for (wageType of listOfWageTypes$ | async; track wageType) {
                          <mat-option [value]="wageType.Id">
                            {{ wageType.Name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  @if (wages.controls[i].get('wageTypeId').value) {
                    @if (isDescriptiveType(wages.controls[i].get('wageTypeId').value)) {
                      <div class="wage-field wage-field--description">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ getWageTypeName(wages.controls[i].get('wageTypeId').value) }}</mat-label>
                          <textarea
                            matInput
                            formControlName="name"
                            maxLength="2000"
                            rows="2"
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="5"
                          ></textarea>
                        </mat-form-field>
                      </div>
                      <div class="wage-field wage-field--description">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'CalculationDescription' | translate }}</mat-label>
                          <textarea
                            matInput
                            formControlName="calculationDescription"
                            maxLength="2000"
                            rows="2"
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="5"
                          ></textarea>
                        </mat-form-field>
                      </div>
                    } @else {
                      <div class="wage-field">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'Wage' | translate }}</mat-label>
                          <input matInput type="number" formControlName="value" min="0" required />
                          @if (wages.controls[i].get('value').hasError('maxWageExceeded')) {
                            <mat-error>
                              {{ 'AF-ExceededMaxWageValue' | translate }}
                            </mat-error>
                          }
                          @if (wages.controls[i].get('value').hasError('minWageExceeded')) {
                            <mat-error>
                              {{ 'AF-NotExceededMinWageValue' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="wage-field wage-field--small">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'Currency' | translate }}</mat-label>
                          <mat-select formControlName="currencyId">
                            @for (currency of listOfCurrencies$ | async; track currency) {
                              <mat-option [value]="currency.Id">
                                {{ currency.Name }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="wage-field">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'Description' | translate }}</mat-label>
                          <mat-select formControlName="wageDescriptionId">
                            <mat-option [value]="null"></mat-option>
                            @for (wageDescription of filterWageDescriptions(listOfWageDescriptions$ | async, i); track wageDescription) {
                              <mat-option [value]="wageDescription.Id">
                                {{ wageDescription.Name }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    }
                  }
                  <div class="wage-actions">
                    <button
                      id="changed-data-step-delete-wage-action-button"
                      mat-icon-button
                      color="warn"
                      type="button"
                      (click)="deleteWage(i)"
                      [disabled]="!canDeleteWage()"
                      [matTooltip]="!isEmploymentAgreementType() 
                        ? ('Annex.CannotRemoveWageForMandate' | translate) 
                        : ('DeleteWage' | translate)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
          } @else {
            @for (wage of wagesDataSource.data; track wage; let i = $index) {
              <div class="wage-row" formArrayName="wages">
                <div class="wage-fields" [formGroupName]="i">
                  <div class="wage-field">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Wage' | translate }}</mat-label>
                      <input matInput type="number" formControlName="value" min="0" required />
                      @if (wages.controls[i].get('value').hasError('maxWageExceeded')) {
                        <mat-error>
                          {{ 'AF-ExceededMaxWageValue' | translate }}
                        </mat-error>
                      }
                      @if (wages.controls[i].get('value').hasError('minWageExceeded')) {
                        <mat-error>
                          {{ 'AF-NotExceededMinWageValue' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="wage-field wage-field--small">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Currency' | translate }}</mat-label>
                      <mat-select formControlName="currencyId">
                        @for (currency of listOfCurrencies$ | async; track currency) {
                          <mat-option [value]="currency.Id">
                            {{ currency.Name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="wage-field">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'WageType' | translate }}</mat-label>
                      <mat-select formControlName="wageTypeId">
                        @for (wageType of listOfWageTypes$ | async; track wageType) {
                          <mat-option [value]="wageType.Id">
                            {{ wageType.Name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="wage-field">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Description' | translate }}</mat-label>
                      <mat-select formControlName="wageDescriptionId">
                        <mat-option [value]="null"></mat-option>
                        @for (wageDescription of filterWageDescriptions(listOfWageDescriptions$ | async, i); track wageDescription) {
                          <mat-option [value]="wageDescription.Id">
                            {{ wageDescription.Name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="wage-actions">
                    <button
                      id="changed-data-step-delete-wage-button"
                      mat-icon-button
                      color="warn"
                      type="button"
                      (click)="deleteWage(i)"
                      [disabled]="!canDeleteWage()"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
          }
          @if (canAddWage$ | async) {
            <button
              id="changed-data-step-add-wage-button"
              mat-raised-button
              color="primary"
              type="button"
              (click)="addNewWage()"
              class="add-wage-button"
            >
              <mat-icon>add_box</mat-icon>
              <span>{{ 'AF-AddWage' | translate }}</span>
            </button>
          }
        </div>
      }
    </div>
  </form>
</div>
